// import React, { useRef } from "react";
// import { FaStar, FaEye, FaUserCheck,FaHeart ,FaEyeSlash , FaUser, FaMapMarkerAlt, FaClock } from "react-icons/fa";
// import { Link, useLocation } from "react-router-dom";

// const MatchesSidebar = () => {
//   const location = useLocation();
//   const sidebarRef = useRef(null);
//   let scrollInterval = null;

//   const menuItems = [
//     {
//       section: "All Matches",
//       items: [
//         {
//           name: "Your Matches",
//           path: "",
//           icon: <FaUser />,
//           description: "View all the profiles that match your preferences"
//         }
//       ]
//     },
//     {
//       section: "Based on activity",
//       items: [
//         { name: "Shortlisted by you", path: "shorted-by-you", icon: <FaHeart />, description: "Matches you have shortlisted" },
//         { name: "Interest ", path: "interest", icon: <FaStar  />, description: "Intrested  profile" },
//         { name: "Ingored By you", path: "ignored-by-you", icon: <FaEyeSlash  />, description: "Profile you ignored" },
//         { name: "Viewed", path: "viewed-by-you", icon: <FaEye />, description: "Matches you have viewed" },
//       ]
//     },
//     {
//       section: "Recently joined & nearby matches",
//       items: [
//         { name: "Newly Joined", path: "/matches/newly-joined", icon: <FaClock />, description: "Matches who joined within the last 30 days" },
//         { name: "Nearby matches", path: "/matches/nearby", icon: <FaMapMarkerAlt />, description: "Matches near your location" },
//       ]
//     }
//   ];

//   return (
//     <div
//       ref={sidebarRef}
//       className="w-full md:w-64 bg-white shadow rounded p-4 overflow-y-auto hide-scrollbar overflow-hidden  h-[calc(100vh-100px)] sticky top-20 relative scroll-smooth"
//     >
//       {/* Hover zones for auto-scroll */}

//       {menuItems.map((section, idx) => (
//         <div key={idx} className="mb-4">
//           <h4 className="text-sm font-semibold text-gray-500 mb-2">{section.section}</h4>
//           {section.items.map((item, i) => (
//             <Link
//               key={i}
//               to={item.path}
//               className={`flex items-start gap-2 p-2 rounded hover:bg-pink-50 transition text-decoration-none ${
//                 location.pathname === item.path ? "bg-pink-50" : ""
//               }`}
//             >
//               <div className="mt-1 text-pink-600">{item.icon}</div>
//               <div>
//                 <p className="text-sm font-medium text-gray-800">{item.name}</p>
//                 <p className="text-xs text-gray-500">{item.description}</p>
//               </div>
//             </Link>
//           ))}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default MatchesSidebar;

import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaUser,
  FaHeart,
  FaStar,
  FaEye,
  FaEyeSlash,
  FaClock,
  FaMapMarkerAlt,
  FaHome,
} from "react-icons/fa";

const MatchesSidebar = ({ onClose }) => {
  const location = useLocation();

  const menuItems = [
    {
      section: "Home",
      items: [
        {
          name: "Your Profile",
          path: "/profile-html-php",
          icon: <FaHome />,
          description: "View all Your profiles details",
        },
      ],
    },
    {
      section: "All Matches",
      items: [
        {
          name: "Your Matches",
          path: "",
          icon: <FaUser />,
          description: "View all profiles matching ",
        },
      ],
    },
    {
      section: "Based on activity",
      items: [
        {
          name: "Shortlisted by you",
          path: "shorted-by-you",
          icon: <FaHeart />,
          description: "Matches you shortlisted",
        },
        {
          name: "Interest",
          path: "interest",
          icon: <FaStar />,
          description: "Profiles you showed interest in",
        },
        {
          name: "Ignored by you",
          path: "ignored-by-you",
          icon: <FaEyeSlash />,
          description: "Profiles you ignored",
        },
        {
          name: "Viewed by you",
          path: "viewed-by-you",
          icon: <FaEye />,
          description: "Profiles you viewed",
        },
      ],
    },
    {
      section: "Recently joined & nearby",
      items: [
        {
          name: "Newly Joined",
          path: "newly-joined",
          icon: <FaClock />,
          description: "Joined in last 30 days",
        },
        // {
        //   name: "Nearby Matches",
        //   path: "/nearby",
        //   icon: <FaMapMarkerAlt />,
        //   description: "Near your location",
        // },
      ],
    },
  ];

  return (
    <div className="pt-14 pl-4 match-sidebar-mobile h-full flex flex-col">
      {menuItems.map((section, idx) => (
        <div key={idx} className="mb-4">
          <h4 className="text-xs font-semibold text-gray-500 uppercase mb-2">
            {section.section}
          </h4>
          <div className="space-y-1">
            {section.items.map((item, i) => {
              const active = location.pathname === item.path;
              return (
                <Link
                  key={i}
                  to={item.path}
                  onClick={() => onClose && onClose()}
                  className={`flex items-center gap-3 p-2 rounded transition text-decoration-none ${
                    active
                      ? "bg-pink-50 text-pink-600 font-semibold"
                      : "hover:bg-gray-50 text-gray-700"
                  }`}
                >
                  <div className="text-pink-500">{item.icon}</div>
                  <div className="flex flex-col">
                    <span className="text-sm">{item.name}</span>
                    <span className="text-xs text-gray-500">
                      {item.description}
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MatchesSidebar;
